(function(window, document) {
    'use strict'

    function initialize() {
        window.RT.analytics.cleanup()
        window.RT.analytics.flush()
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, {once: true})
    } else {
        initialize()
    }

    window.addEventListener('online', function() {
        window.RT.analytics.flush()
    })

    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
            window.RT.analytics.flush()
        }
    })
})(window, document)
